import Link from '@components/ui/Link'
import cn from 'clsx'
import { useRouter } from 'next/router'
import { FC } from 'react'
import s from './index.module.css'

interface Link {
  Label: string
  Link: string
}

interface Props {
  navItems: Link[]
}
const CategoryNav: FC<Props> = ({ navItems }) => {
  const { asPath } = useRouter()

  return (
    <>
      <div className="flex w-full mt-4 mb-2">
        <div className="flex flex-row flex-wrap justify-start gap-2.5">
          {navItems.map((link) => (
            <Link
              key={link.Label}
              className={cn('px-4 py-2 border rounded-sm text-body2 shrink-0', {
                'border-brand-chrome': asPath === link.Link,
                'border-ui-grey-25 hover:opacity-75': asPath !== link.Link,
              })}
              href={link.Link}
            >
              {link.Label}
            </Link>
          ))}
          <div className={s.padding_compensate}></div>
        </div>
      </div>
    </>
  )
}

export default CategoryNav
